let pendingToken = "";

export function storeEmailChangeToken(value) {
  const candidate = typeof value === "string" ? value.trim() : "";
  pendingToken = /^[a-f0-9]{64}$/i.test(candidate) ? candidate : "";
}

export function consumeEmailChangeToken() {
  const token = pendingToken;
  pendingToken = "";
  return token;
}

// index.html removes the fragment before any third-party script runs. Move its
// one-shot handoff into module-private memory as soon as the app bundle starts.
if (typeof window !== "undefined") {
  storeEmailChangeToken(window.__rmeEmailChangeBootstrapToken);
  try {
    delete window.__rmeEmailChangeBootstrapToken;
  } catch {
    window.__rmeEmailChangeBootstrapToken = "";
  }
}
